const CAMELOT_KEY_CONVERSION: { [index: string]: string[] } = {
  // Note: The values of this table also exist in backend, in different table form. And it's also in key-converter.ts
  '1A': ['Abm', 'G#m', 'G#min', '6m'],
  '2A': ['Ebm', 'D#m', 'D#min', '7m'], // D#m = Ebm
  '3A': ['Bbm', '8m'],
  '4A': ['Fm', 'Fmin', '9m'],
  '5A': ['Cm', 'Cmin', '10m'],
  '6A': ['Gm', 'Gmin', '11m'],
  '7A': ['Dm', 'Dmin', '12m'],
  '8A': ['Am', 'Amin', '1m'],
  '9A': ['Em', 'Emin', '2m'],
  '10A': ['Bm', 'Bmin', '3m'],
  '11A': ['F#m', 'F#min', 'Gbm', '4m'],
  '12A': ['Dbm', 'C#m', 'C#min', '5m'],
  '1B': ['B', 'Bmaj', '6d'],
  '2B': ['F#', 'Gb', '7d'],
  '3B': ['Db', '8d'],
  '4B': ['Ab', '9d'],
  '5B': ['Eb', '10d'],
  '6B': ['Bb', '11d'],
  '7B': ['F', 'Fmaj', '12d'],
  '8B': ['C', 'Cmaj', '1d'],
  '9B': ['G', 'Gmaj', '2d'],
  '10B': ['D', 'Dmaj', '3d'],
  '11B': ['A', 'Amaj', '4d'],
  '12B': ['E', 'Emaj', '5d'] // TODO: does this work for all keys? like 04M
}

export function isOpenKey(key: string): boolean {
  return /^\d{1,2}[dm]$/i.test(key)
}

export function isCamelotKey(key: string): boolean {
  return /^\d{1,2}[ab]$/i.test(key)
}

function openKeyToCamelot(key: string): string {
  let letter = key[key.length - 1].toLowerCase()

  if (letter === 'm') letter = 'a'
  else if (letter === 'd') letter = 'b'

  let n = parseInt(key.slice(0, key.length - 1))

  n = (n + 7) % 12

  if (n === 0) n = 12

  return `${n}${letter.toUpperCase()}`
}

export function toCamelotKey(key: string): string {
  if (!key) return ''

  key = key.toLowerCase()

  if (isCamelotKey(key)) return key // If already in camelot notation
  if (isOpenKey(key)) return openKeyToCamelot(key)

  for (const camelotKey in CAMELOT_KEY_CONVERSION) {
    if (CAMELOT_KEY_CONVERSION[camelotKey].some(k => k.toLowerCase() === key)) {
      return camelotKey
    }
  }

  return key
}

export function isSimilarKey(key: string, baseKey: string): boolean {
  key = key.toLowerCase()
  baseKey = baseKey.toLowerCase()

  key = toCamelotKey(key).toLowerCase()

  // Remove leading 0
  if (key[0] === '0') key = key.substring(1, key.length)
  if (baseKey[0] === '0') baseKey = baseKey.substring(1, baseKey.length)

  if (key === baseKey) return true

  if (baseKey === '1b') return key === '12b' || key === '2b' || key === '1a'
  if (baseKey === '2b') return key === '1b' || key === '3b' || key === '2a'
  if (baseKey === '3b') return key === '2b' || key === '4b' || key === '3a'
  if (baseKey === '4b') return key === '3b' || key === '5b' || key === '4a'
  if (baseKey === '5b') return key === '4b' || key === '6b' || key === '5a'
  if (baseKey === '6b') return key === '5b' || key === '7b' || key === '6a'
  if (baseKey === '7b') return key === '6b' || key === '8b' || key === '7a'
  if (baseKey === '8b') return key === '7b' || key === '9b' || key === '8a'
  if (baseKey === '9b') return key === '8b' || key === '10b' || key === '9a'
  if (baseKey === '10b') return key === '9b' || key === '11b' || key === '10a'
  if (baseKey === '11b') return key === '10b' || key === '12b' || key === '11a'
  if (baseKey === '12b') return key === '11b' || key === '1b' || key === '12a'

  if (baseKey === '1a') return key === '1b' || key === '12a' || key === '2a'
  if (baseKey === '2a') return key === '2b' || key === '1a' || key === '3a'
  if (baseKey === '3a') return key === '3b' || key === '2a' || key === '4a'
  if (baseKey === '4a') return key === '4b' || key === '3a' || key === '5a'
  if (baseKey === '5a') return key === '5b' || key === '4a' || key === '6a'
  if (baseKey === '6a') return key === '6b' || key === '5a' || key === '7a'
  if (baseKey === '7a') return key === '7b' || key === '6a' || key === '8a'
  if (baseKey === '8a') return key === '8b' || key === '7a' || key === '9a'
  if (baseKey === '9a') return key === '9b' || key === '8a' || key === '10a'
  if (baseKey === '10a') return key === '10b' || key === '9a' || key === '11a'
  if (baseKey === '11a') return key === '11b' || key === '10a' || key === '12a'
  if (baseKey === '12a') return key === '12b' || key === '11a' || key === '1a'

  return false
}
